var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u(
        [
          _vm.isEmbedded
            ? {
                key: "card-header",
                fn: function () {
                  return [
                    _c(
                      "b-button",
                      {
                        staticClass: "p-0",
                        attrs: { variant: "link" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("back")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n      ← " +
                            _vm._s(_vm.$t("global.words.back")) +
                            "\n    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "bold" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t("financial-tools.amortizationSchedule")
                          ) +
                          "\n    "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              }
            : null,
          {
            key: "card-footer",
            fn: function () {
              return [
                _c("mortgage-calculators-toolbar", {
                  attrs: {
                    "show-calculate": false,
                    "is-loading": _vm.isLoading,
                    "loading-succeeded": _vm.loadingSucceeded,
                  },
                  on: {
                    "clear-selection": _vm.clearForm,
                    "run-report": _vm.runReport,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _c(
        "span",
        [
          _c("b-row", { staticClass: "ml-1" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("financial-tools.description")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.mortgage_amount")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "totalLoanAmount",
                      placeholder: "0",
                      "class-name": "fe-num-field dollar",
                      "allow-minus": false,
                      label: _vm
                        .$t("financial-tools.mortgage_amount")
                        .toString(),
                      "show-tooltip-message": true,
                      max: "100000000",
                      "max-length": 14,
                    },
                    model: {
                      value: _vm.formData.totalLoanAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "totalLoanAmount", $$v)
                      },
                      expression: "formData.totalLoanAmount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.interest_rate")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "1" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      placeholder: "0",
                      "class-name": "fe-num-field decimal-input",
                      decimals: 3,
                      "allow-minus": false,
                      label: _vm.$t("financial-tools.interest_rate").toString(),
                      max: "100",
                      "max-length": 6,
                      "show-tooltip-message": true,
                    },
                    model: {
                      value: _vm.formData.interestRate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "interestRate", $$v)
                      },
                      expression: "formData.interestRate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2 pl-3",
                  attrs: { cols: "12", sm: "1" },
                },
                [_vm._v(" % ")]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.interestOnly")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pt-2", attrs: { cols: "12", sm: "1" } },
                [
                  _c("b-form-checkbox", {
                    on: { change: _vm.handleInterestOnlyChange },
                    model: {
                      value: _vm.formData.interestOnly,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "interestOnly", $$v)
                      },
                      expression: "formData.interestOnly",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.sc_list1_Term")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "1" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "term",
                      placeholder: "0",
                      "class-name": "fe-num-field",
                      "allow-minus": false,
                      label: _vm.$t("financial-tools.sc_list1_Term").toString(),
                      "show-tooltip-message": true,
                      max: "999",
                      "max-length": 3,
                    },
                    model: {
                      value: _vm.formData.term,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "term", $$v)
                      },
                      expression: "formData.term",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "1" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.monthss")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.amortization")) +
                      ":\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("years-months-section", {
                    attrs: {
                      name: "amortizPeriodMths",
                      placeholder: "0",
                      "class-name": "fe-num-field",
                      "allow-minus": false,
                      disabled: _vm.formData.interestOnly,
                      label: _vm.$t("financial-tools.amortization_period"),
                      "show-tooltip-message": true,
                    },
                    model: {
                      value: _vm.formData.amortizPeriodMths,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "amortizPeriodMths", $$v)
                      },
                      expression: "formData.amortizPeriodMths",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.paymentFrequency")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-0", attrs: { cols: "12", sm: "2" } },
                [
                  _c("select-section", {
                    attrs: {
                      name: "frequency",
                      options: _vm.mortgageFrequencyOptions,
                      required: true,
                      "placeholder-option": false,
                    },
                    model: {
                      value: _vm.formData.frequency,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "frequency", $$v)
                      },
                      expression: "formData.frequency",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.compounded")) +
                      ":\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-0", attrs: { cols: "12", sm: "2" } },
                [
                  _c("select-section", {
                    attrs: {
                      name: "compounded",
                      options: _vm.compoundedOptions,
                      required: true,
                      "placeholder-option": false,
                    },
                    model: {
                      value: _vm.formData.compounded,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "compounded", $$v)
                      },
                      expression: "formData.compounded",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.payment")) +
                      ":\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "payment",
                      placeholder: "0",
                      "class-name": "fe-num-field dollar",
                      "allow-minus": false,
                      disabled: !_vm.formData.paymentOverride,
                      label: _vm.$t("financial-tools.payment").toString(),
                      "show-tooltip-message": true,
                      max: "100000000",
                      "max-length": 14,
                    },
                    model: {
                      value: _vm.formData.payment,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "payment", $$v)
                      },
                      expression: "formData.payment",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.paymentOverride")) +
                      ":\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pt-2", attrs: { cols: "12", sm: "1" } },
                [
                  _c("b-form-checkbox", {
                    on: { change: _vm.handlePaymentOverrideChange },
                    model: {
                      value: _vm.formData.paymentOverride,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "paymentOverride", $$v)
                      },
                      expression: "formData.paymentOverride",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-row", { staticClass: "mt-2" }, [_c("b-col", [_vm._v(" ")])], 1),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-1" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("global.doorr.closingDate")) +
                      ":\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "field",
                {
                  attrs: {
                    "size-class": "col-12 col-sm-2 m-0 p-0 mr-0 pb-1",
                    "container-class": "date-inline-field",
                  },
                },
                [
                  _c("date-section", {
                    attrs: {
                      name: "closingDate",
                      placeholder: "YYYY-MM-DD",
                      "class-name": "date-format",
                      calendar: "",
                    },
                    model: {
                      value: _vm.formData.closingDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "closingDate", $$v)
                      },
                      expression: "formData.closingDate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.amortizationScenario")) +
                      ":\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-0", attrs: { cols: "12", sm: "6" } },
                [
                  _c("select-section", {
                    attrs: {
                      name: "amortizationScenario",
                      options: _vm.amortizationScenarioOptions,
                      required: false,
                      "placeholder-option": true,
                    },
                    model: {
                      value: _vm.formData.amortizationScenario,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "amortizationScenario", $$v)
                      },
                      expression: "formData.amortizationScenario",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("application-form.interest-adjustment-date")
                      ) +
                      ":\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "field",
                {
                  attrs: {
                    "size-class": "col-12 col-sm-2 m-0 p-0 mr-0 pb-1",
                    "container-class": "date-inline-field",
                  },
                },
                [
                  _c("date-section", {
                    attrs: {
                      name: "interestAdjustmentDate",
                      placeholder: "YYYY-MM-DD",
                      "class-name": "date-format",
                      calendar: "",
                    },
                    model: {
                      value: _vm.formData.interestAdjustmentDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "interestAdjustmentDate", $$v)
                      },
                      expression: "formData.interestAdjustmentDate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.extraPaymentAmount")) +
                      ":\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.isTopExtraPaymentAmountEditable
                ? _c(
                    "b-col",
                    {
                      staticClass: "m-0 p-0 mr-0 pb-1",
                      attrs: { cols: "12", sm: "2" },
                    },
                    [
                      _c("text-section", {
                        attrs: {
                          name: "extraPaymentAmount",
                          placeholder: "0",
                          "class-name": "fe-num-field dollar",
                          "allow-minus": false,
                          label: _vm
                            .$t("financial-tools.extraPaymentAmount")
                            .toString(),
                          "show-tooltip-message": true,
                          max: "100000",
                          "max-length": 10,
                        },
                        model: {
                          value: _vm.formData.extraPaymentAmount,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "extraPaymentAmount", $$v)
                          },
                          expression: "formData.extraPaymentAmount",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("application-form.first-payment-date")) +
                      ":\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "field",
                {
                  attrs: {
                    "size-class": "col-12 col-sm-2 m-0 p-0 mr-0 pb-1",
                    "container-class": "date-inline-field",
                  },
                },
                [
                  _c("date-section", {
                    attrs: {
                      name: "firstPaymentDate",
                      placeholder: "YYYY-MM-DD",
                      "class-name": "date-format",
                      calendar: "",
                    },
                    model: {
                      value: _vm.formData.firstPaymentDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "firstPaymentDate", $$v)
                      },
                      expression: "formData.firstPaymentDate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.prepared_for")) +
                      ":\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "6" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "preparedFor",
                      placeholder: "",
                      label: _vm.$t("financial-tools.prepared_for").toString(),
                      "show-tooltip-message": false,
                      "max-length": 100,
                    },
                    model: {
                      value: _vm.formData.preparedFor,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "preparedFor", $$v)
                      },
                      expression: "formData.preparedFor",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("financial-tools.interestAdjustmentAmount")
                      ) +
                      ":\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 pt-2 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.formatMoneyValueLong(
                          _vm.roundReg(_vm.interestAdjustmentAmount)
                        )
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.isEmbedded
                ? _c(
                    "b-col",
                    {
                      staticClass: "align-items-center pt-2",
                      attrs: { cols: "12", sm: "2" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("financial-tools.agent")) +
                          ":\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEmbedded
                ? _c(
                    "b-col",
                    {
                      staticClass: "m-0 p-0 mr-0 pb-1",
                      attrs: { cols: "12", sm: "6" },
                    },
                    [
                      _c("agents-select", {
                        attrs: {
                          value: _vm.formData.agentUsername,
                          multiple: false,
                          "material-design": false,
                          label: _vm.$t("financial-tools.agent").toString(),
                        },
                        on: { change: _vm.handleAgentChange },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-md-2 ml-0 btn-sm",
                      attrs: { variant: "white" },
                      on: {
                        click: function ($event) {
                          return _vm.calculate()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("financial-tools.calculate")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-md-2 ml-0 btn-sm",
                      attrs: { variant: "white" },
                      on: {
                        click: function ($event) {
                          return _vm.clearAllExtraPayments()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("financial-tools.clearAllExtraPayments")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-md-2 ml-0 btn-sm",
                      attrs: { variant: "white" },
                      on: {
                        click: function ($event) {
                          return _vm.clearForm()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("financial-tools.clear")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-md-2 ml-0 btn-sm",
                      attrs: {
                        variant: "white",
                        disabled:
                          _vm.isLoading ||
                          _vm.hasPendingPaymentStructureChanges,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.runReport()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("financial-tools.print")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.scenarios.length > 0
            ? _c(
                "div",
                { staticClass: "mt-4" },
                [
                  _c("hr", {
                    staticClass: "w-100 mt-2",
                    staticStyle: { "border-top": "2px solid #ccc" },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-table-simple",
                    { attrs: { small: "", bordered: "", responsive: "" } },
                    [
                      _c(
                        "b-thead",
                        { attrs: { "head-variant": "light" } },
                        [
                          _c(
                            "b-tr",
                            [
                              _c("b-th"),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v("#"),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("financial-tools.mortgage_amount")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("financial-tools.amortization")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("financial-tools.interest_rate")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("financial-tools.sc_list1_Term")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("financial-tools.payment")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("financial-tools.frequency")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("financial-tools.interestOnly")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("financial-tools.balanceRemaining")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tbody",
                        _vm._l(_vm.scenarios, function (sc, idx) {
                          return _c(
                            "b-tr",
                            {
                              key: "sc-" + idx,
                              class: { formbg: idx % 2 === 1 },
                            },
                            [
                              _c(
                                "b-td",
                                { staticClass: "text-center" },
                                [
                                  _c("b-form-radio", {
                                    attrs: {
                                      value: idx,
                                      name: "scenarioSelection",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onScenarioSelect(idx)
                                      },
                                    },
                                    model: {
                                      value: _vm.selectedScenarioIndex,
                                      callback: function ($$v) {
                                        _vm.selectedScenarioIndex = $$v
                                      },
                                      expression: "selectedScenarioIndex",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(idx + 1)),
                              ]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.formatMoneyValueLong(
                                        sc.totalLoanAmount
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(sc.amortization)),
                              ]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(
                                  _vm._s(sc.interestRate.toFixed(3)) + " %"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(sc.term)),
                              ]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.formatMoneyValueLong(
                                        _vm.roundReg(sc.payment)
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(sc.frequencyLabel)),
                              ]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(
                                  _vm._s(
                                    sc.interestOnly
                                      ? _vm.$t("financial-tools.yesAbbr")
                                      : "N"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.formatMoneyValueLong(
                                        _vm.roundReg(sc.balanceRemaining)
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-end mr-1" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-2 btn-sm",
                          attrs: { variant: "white" },
                          on: {
                            click: function ($event) {
                              return _vm.clearSelectedScenario()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("financial-tools.clearSelected")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-2 btn-sm",
                          attrs: { variant: "white" },
                          on: {
                            click: function ($event) {
                              return _vm.clearAllScenarios()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("financial-tools.clearAll")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.scheduleRows.length > 0
            ? _c(
                "div",
                { staticClass: "mt-4" },
                [
                  _c("hr", {
                    staticClass: "w-100 mt-2",
                    staticStyle: { "border-top": "3px solid black" },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-table-simple",
                    {
                      staticClass: "mt-2",
                      attrs: { small: "", bordered: "", responsive: "" },
                    },
                    [
                      _c(
                        "b-thead",
                        { attrs: { "head-variant": "light" } },
                        [
                          _c(
                            "b-tr",
                            [
                              _c(
                                "b-th",
                                {
                                  staticClass: "text-center font-weight-bold",
                                  attrs: { colspan: "2" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("financial-tools.summary")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-th",
                                {
                                  staticClass: "text-center font-weight-bold",
                                  attrs: { colspan: "3" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("financial-tools.scenario")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-th",
                                {
                                  staticClass: "text-center font-weight-bold",
                                  attrs: { colspan: "3" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("financial-tools.original")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tr",
                            [
                              _c(
                                "b-th",
                                {
                                  staticClass: "text-center",
                                  staticStyle: { width: "100px" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("financial-tools.extraPayments")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-th",
                                {
                                  staticClass: "text-center",
                                  staticStyle: { width: "80px" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("financial-tools.paymentNumber")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("financial-tools.interest")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("financial-tools.principal")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("application-form.balance")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("financial-tools.interest")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("financial-tools.principal")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("application-form.balance")) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tbody",
                        _vm._l(_vm.scheduleRows, function (row, idx) {
                          return _c(
                            "b-tr",
                            {
                              key: "row-" + idx,
                              class: { formbg: idx % 2 === 1 },
                            },
                            [
                              _c(
                                "b-td",
                                { staticClass: "text-center" },
                                [
                                  _vm.hasScenario
                                    ? [
                                        row.scenarioRowEditKind === "amount"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "payment-structure-editor",
                                              },
                                              [
                                                _c("text-section", {
                                                  attrs: {
                                                    value:
                                                      row.scenarioRowAmountInput ||
                                                      "",
                                                    name:
                                                      "scenario-row-amount-" +
                                                      row.paymentNum,
                                                    placeholder: "0",
                                                    "class-name":
                                                      "fe-num-field dollar payment-structure-field",
                                                    "allow-minus": false,
                                                    label: _vm
                                                      .$t(
                                                        "financial-tools.extraPaymentAmount"
                                                      )
                                                      .toString(),
                                                    "show-tooltip-message": false,
                                                    "show-max-length-label": false,
                                                    max: "100000000",
                                                    "max-length": 14,
                                                    "container-class":
                                                      "payment-structure-container",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.handleScenarioRowAmountChange(
                                                        row.paymentNum,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : row.scenarioRowEditKind ===
                                            "amount-or-percent"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "payment-structure-editor payment-structure-editor--dual",
                                              },
                                              [
                                                _c("text-section", {
                                                  attrs: {
                                                    value:
                                                      row.scenarioRowAmountInput ||
                                                      "",
                                                    name:
                                                      "scenario-row-amount-" +
                                                      row.paymentNum,
                                                    placeholder: "0",
                                                    "class-name":
                                                      "fe-num-field dollar payment-structure-field",
                                                    "allow-minus": false,
                                                    disabled:
                                                      row.scenarioRowPercentInput >
                                                      0,
                                                    label: _vm
                                                      .$t(
                                                        "financial-tools.extraPaymentAmount"
                                                      )
                                                      .toString(),
                                                    "show-tooltip-message": false,
                                                    "show-max-length-label": false,
                                                    max: "100000000",
                                                    "max-length": 14,
                                                    "container-class":
                                                      "payment-structure-container",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.handleScenarioRowAmountChange(
                                                        row.paymentNum,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "payment-structure-divider",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "global.words.or"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("text-section", {
                                                  attrs: {
                                                    value:
                                                      row.scenarioRowPercentInput ||
                                                      "",
                                                    name:
                                                      "scenario-row-percent-" +
                                                      row.paymentNum,
                                                    placeholder: "0",
                                                    "class-name":
                                                      "fe-num-field decimal-input payment-structure-field",
                                                    "allow-minus": false,
                                                    disabled:
                                                      row.scenarioRowAmountInput >
                                                      0,
                                                    decimals: 3,
                                                    label: _vm
                                                      .$t(
                                                        "application-standalone.labels.percentage"
                                                      )
                                                      .toString(),
                                                    "show-tooltip-message": false,
                                                    "show-max-length-label": false,
                                                    max: "100",
                                                    "max-length": 6,
                                                    "container-class":
                                                      "payment-structure-container",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.handleScenarioRowPercentChange(
                                                        row.paymentNum,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "payment-structure-percent-label",
                                                  },
                                                  [_vm._v("%")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm.hasScenario &&
                                            row.extraPayment > 0
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.formatMoneyValueLong(
                                                      _vm.roundReg(
                                                        row.extraPayment
                                                      )
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    : _c("span", [_vm._v(" ")]),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(row.paymentNum)),
                              ]),
                              _vm._v(" "),
                              _vm.hasScenario
                                ? [
                                    _c("b-td", { staticClass: "text-center" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.formatMoneyValueLong(
                                              _vm.roundReg(row.scenarioInterest)
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", { staticClass: "text-center" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.formatMoneyValueLong(
                                              _vm.roundReg(
                                                row.scenarioPrincipal
                                              )
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", { staticClass: "text-center" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.formatMoneyValueLong(
                                              _vm.roundReg(row.scenarioBalance)
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]
                                : [
                                    _c("b-td", { staticClass: "text-center" }, [
                                      _vm._v(" "),
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", { staticClass: "text-center" }, [
                                      _vm._v(" "),
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", { staticClass: "text-center" }, [
                                      _vm._v(" "),
                                    ]),
                                  ],
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.formatMoneyValueLong(
                                        _vm.roundReg(row.originalInterest)
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.formatMoneyValueLong(
                                        _vm.roundReg(row.originalPrincipal)
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.formatMoneyValueLong(
                                        _vm.roundReg(row.originalBalance)
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            2
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tfoot",
                        [
                          _c(
                            "b-tr",
                            { staticClass: "bg-light" },
                            [
                              _c("b-th"),
                              _vm._v(" "),
                              _c("b-th"),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("financial-tools.interest")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("financial-tools.principal")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("application-form.balance")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("financial-tools.interest")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("financial-tools.principal")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("application-form.balance")) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tr",
                            [
                              _c("b-td"),
                              _vm._v(" "),
                              _c("b-td", { staticClass: "text-right bold" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("financial-tools.totals")) +
                                    ":\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.hasScenario
                                ? [
                                    _c(
                                      "b-td",
                                      {
                                        staticClass: "text-center bold",
                                        staticStyle: {
                                          border: "1px solid black",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.formatMoneyValueLong(
                                                _vm.roundReg(
                                                  _vm.scenarioTotals.interest
                                                )
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-td",
                                      {
                                        staticClass: "text-center bold",
                                        staticStyle: {
                                          border: "1px solid black",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.formatMoneyValueLong(
                                                _vm.roundReg(
                                                  _vm.scenarioTotals.principal
                                                )
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-td",
                                      {
                                        staticClass: "text-center bold",
                                        staticStyle: {
                                          border: "1px solid black",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.formatMoneyValueLong(
                                                _vm.roundReg(
                                                  _vm.scenarioTotals.balance
                                                )
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                : [
                                    _c("b-td", {
                                      staticClass: "text-center bold",
                                      staticStyle: {
                                        border: "1px solid black",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("b-td", {
                                      staticClass: "text-center bold",
                                      staticStyle: {
                                        border: "1px solid black",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("b-td", {
                                      staticClass: "text-center bold",
                                      staticStyle: {
                                        border: "1px solid black",
                                      },
                                    }),
                                  ],
                              _vm._v(" "),
                              _c(
                                "b-td",
                                {
                                  staticClass: "text-center bold",
                                  staticStyle: { border: "1px solid black" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.formatMoneyValueLong(
                                          _vm.roundReg(
                                            _vm.originalTotals.interest
                                          )
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-td",
                                {
                                  staticClass: "text-center bold",
                                  staticStyle: { border: "1px solid black" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.formatMoneyValueLong(
                                          _vm.roundReg(
                                            _vm.originalTotals.principal
                                          )
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-td",
                                {
                                  staticClass: "text-center bold",
                                  staticStyle: { border: "1px solid black" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.formatMoneyValueLong(
                                          _vm.roundReg(
                                            _vm.originalTotals.balance
                                          )
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasScenario
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-end mr-1 mt-3" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "ml-2 btn-sm",
                              attrs: {
                                variant: "white",
                                disabled:
                                  !_vm.canCalculateWithNewPaymentStructure,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.calculateWithNewPaymentStructure()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "financial-tools.calculateWithNewPaymentStructure"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                        _vm._v(" "),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "4" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("financial-tools.amortizationRemaining")
                            ) +
                            ":\n          " +
                            _vm._s(_vm.footerData.effectiveAmortization) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                        _vm._v(" "),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "4" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("financial-tools.interestSavedOverTerm")
                            ) +
                            ":\n          " +
                            _vm._s(
                              _vm.formatMoneyValueLong(
                                _vm.roundReg(
                                  _vm.footerData.interestSavedOverTerm
                                )
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                        _vm._v(" "),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "5" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "financial-tools.interestSavedOverAmortization"
                              )
                            ) +
                            ":\n          " +
                            _vm._s(
                              _vm.formatMoneyValueLong(
                                _vm.roundReg(
                                  _vm.footerData.interestSavedOverAmortization
                                )
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("b-row", { staticClass: "mt-4 ml-1" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("financial-tools.DHdisclaimer")) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }